/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TCancelUserResponseModel,
  ICancelUserResponseRequest,
  IMappers,
  ICancelUserResponseResponseError,
  TCancelUserResponseResponse,
} from './types';

const defaultConfig: TCancelUserResponseModel = {
  apiType: 'public',
  assertStatusCodes: [204, 400],
  method: 'POST',
  microserviceName: 'moderation-checks-orchestrator',
  pathApi: '/v2/cancel-user-response/',
  hostType: 'api',
} as TCancelUserResponseModel;

function createCancelUserResponseModel(parameters: ICancelUserResponseRequest): TCancelUserResponseModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICancelUserResponseOptions<TResponse204, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICancelUserResponseRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse204, TResponse400>;
}

async function fetchCancelUserResponse<TResponse204, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ICancelUserResponseOptions<TResponse204, TResponse400>): Promise<
  TResponse204 | TResponse400 | TCancelUserResponseResponse
> {
  const { response, statusCode } = await httpApi.fetch(createCancelUserResponseModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 204) {
      return mappers[204]();
    }

    if (statusCode === 400) {
      return mappers[400](response as ICancelUserResponseResponseError);
    }
  }

  return { response, statusCode } as TCancelUserResponseResponse;
}

export { defaultConfig, createCancelUserResponseModel, fetchCancelUserResponse };
